export default "__VITE_ASSET__638e6914__"